export default __webpack_public_path__ + "static/media/eva-img.41f9ea60.jpg";